export class UserCanNotUpdateActionError extends Error {
  constructor(message = 'User is not authorized to update this action') {
    super(message);
    this.name = 'UserCanNotUpdateActionError';
  }
}
